<template>
  <div class="p-4 w-100">
    <h2 class="mb-4">{{ $t('competition.legend') }}</h2>
    <div v-if="type === 'group'">
      <ul>
        <li v-if="spec === 'stepladder' || !spec">
          <h3>Stepladder</h3>
          <h5>{{ $t('competition.stepladder') }}</h5>
        </li>
        <li v-if="spec === 'single' || !spec">
          <h3>Single Elimination</h3>
          <h5 v-if="qty && qty.toString() === '3'">{{ $t('competition.single_elimination', {
            skipped: $t('competition.single3')
          }) }}</h5>
          <h5 v-else>{{ $t('competition.single_elimination', {
            skipped: $t('competition.single24')
          }) }}</h5> 
        </li>
        <li v-if="spec === 'wildcard' || !spec">
          <h3>Wildcard</h3>
          <h5>{{ $t('competition.wildcard') }}</h5>
        </li>
      </ul>
    </div>
    <div v-else-if="type === 'circuit'">
      <ul>
        <li v-if="spec === 'oneway' || !spec">
          <h3>{{ $t('competition.circuit1') }}</h3>
          <h5>{{ $t('competition.circuit1_description') }}</h5>
        </li>
        <li v-if="spec === 'twoway' || !spec">
          <h3>{{ $t('competition.circuit2') }}</h3>
          <h5>{{ $t('competition.circuit2_description') }}</h5>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import storeMixin from '../storeMixin';

export default {
  name: 'FormatLegend',
  data() {
    return storeMixin;
  },
};
</script>

<style scoped>
.final-standing-clamt-text {
  width: 100%;
}

table {
  table-layout: fixed;
}

.w-75px {
  width: 75px;
  min-width: 75px;
}

.match-table {
  width: 100%;
}

.match-table.table-bordered tr td,
.match-table.table-bordered tr th {
  border-width: 1px !important;
}

.match-table.table-bordered td {
  border: none !important;
}

.tournament-stage .match-table td:hover {
  background: transparent !important;
}

.match-table td:hover {
  background: #e4e4e4;
}

.gold {
  background-color: #ffed9a;
}

.silver {
  background-color: #eeeeee;
}

.bronze {
  background-color: #f9e8c7;
}

.copper {
  background-color: #f9dec7;
}

.gold-medal {
  color: gold;
  filter: drop-shadow(0px 0px 0.1rem black);
}

.silver-medal {
  color: silver;
  filter: drop-shadow(0px 0px 0.1rem black);
}

.bronze-medal {
  color: burlywood;
  filter: drop-shadow(0px 0px 0.1rem black);
}

.copper-medal {
  color: rosybrown;
  filter: drop-shadow(0px 0px 0.1rem black);
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/FormatLegend.vue